import { MillwrightLastFatigueWarning as MillwrightLastFatigueWarningI } from '@/apis/incidents/types/incidentsApi';
import { DataItems } from '@/components';
import { formatDateString } from '@/utils';
import {
  BoxAppstore,
  Typography,
} from '@data-products-and-ai/react-components';
import { FC, useMemo } from 'react';

interface MillwrightLastFatigueWarningProps {
  data?: MillwrightLastFatigueWarningI;
}

export const MillwrightLastFatigueWarning: FC<
  MillwrightLastFatigueWarningProps
> = ({ data: daysSinceLastWarning }) => {
  const dataItems = useMemo(
    () => [
      {
        key: 'dateWarning',
        label: 'Warning Date',
        value: (
          <Typography tag="textsmall_strong" color="var(--color-black)">
            {daysSinceLastWarning?.lastWarningDate
              ? formatDateString(
                  daysSinceLastWarning.lastWarningDate,
                  'MMMM Do, YYYY',
                )
              : 'N/A'}
          </Typography>
        ),
      },
      {
        key: 'incidentWarning',
        label: 'Days passed',
        value: (
          <Typography tag="textsmall_strong" color="var(--color-black)">
            {daysSinceLastWarning?.daysSinceLastWarning
              ? daysSinceLastWarning?.daysSinceLastWarning.toString()
              : 'N/A'}
          </Typography>
        ),
      },
    ],
    [daysSinceLastWarning],
  );

  if (!daysSinceLastWarning) return null;

  return (
    <BoxAppstore>
      <Typography tag="h4">Days Passed From Last Fatigue Warning</Typography>
      <br />
      <DataItems items={dataItems} />
    </BoxAppstore>
  );
};
